/*
 *  TTTech nerve-management-system-frontend
 *  Copyright(c) 2026. TTTech Industrial Automation AG.
 *
 *  ALL RIGHTS RESERVED.
 *
 *  Usage of this software, including source code, netlists, documentation,
 *  is subject to restrictions and conditions of the applicable license
 *  agreement with TTTech Industrial Automation AG or its affiliates.
 *
 *  All trademarks used are the property of their respective owners.
 *
 *  TTTech Industrial Automation AG and its affiliates do not assume any liability
 *  arising out of the application or use of any product described or shown
 *  herein. TTTech Industrial Automation AG and its affiliates reserve the right to
 *  make changes, at any time, in order to improve reliability, function or
 *  design.
 *
 *  Contact Information:
 *  support@tttech-industrial.com
 *
 *  TTTech Industrial Automation AG, Schoenbrunnerstrasse 7, 1040 Vienna, Austria
 *
 */

export default class CampaignTaskModel {
  static formatStarted(timeOfTaskStart) {
    return timeOfTaskStart ? new Date(timeOfTaskStart).toLocaleString('en-GB') : '';
  }

  static formatStatus(status) {
    const normalizedStatus = (status || '').toString().trim().toLowerCase().replace(/_/g, ' ');

    if (!normalizedStatus) {
      return '';
    }

    return normalizedStatus === 'created'
      ? 'In progress'
      : normalizedStatus.charAt(0).toUpperCase() + normalizedStatus.slice(1);
  }

  static formatFinished(status, taskFinishedTimestamp, errorFeedback) {
    const normalizedStatus = (status || '').toString().trim().toUpperCase();

    if (normalizedStatus === 'SUCCESS') {
      return taskFinishedTimestamp ? new Date(taskFinishedTimestamp).toLocaleString('en-GB') : 'In progress';
    }

    if (normalizedStatus === 'ERROR' || normalizedStatus === 'FAIL' || normalizedStatus === 'FAILED') {
      return errorFeedback?.timeOfFail ? new Date(errorFeedback.timeOfFail).toLocaleString('en-GB') : 'In progress';
    }

    return 'In progress';
  }

  static formatProgress(progress) {
    if (progress === 0 || progress) {
      return parseFloat(progress).toFixed(2);
    }
    return '';
  }

  constructor(data = {}) {
    this.id = data._id || '';
    this.device = data.device;
    this.deviceName = data.deviceName || '';
    this.action = data.deploymentType || ''; // set only for workload deployments

    this.started = CampaignTaskModel.formatStarted(data.timeOfTaskStart);
    this.finished = CampaignTaskModel.formatFinished(
      data.taskOptions?.status,
      data.taskFinishedTimestamp,
      data.errorFeedback,
    );

    this.status = CampaignTaskModel.formatStatus(data.taskOptions?.status);

    this.progress = CampaignTaskModel.formatProgress(data.progress ?? data.taskOptions?.progress);
    this.errorFeedback = data.errorFeedback;
  }
}
